import {BrowserRouter, Route as BrowserRoute, Routes as BrowserRoutes} from "react-router-dom";
import Routes from './Routes';
import {Route} from './Routes';
import Secured from "./Secured";
import Layout from "../pages/_layout/Layout";
import Login from "../pages/login/Login";

/**
 * Entire application router [including layout]
 * @author Kacper Faber
 * @since 0.1.0
 * @constructor
 */
function AppRouter() {
    /**
     * Render <Route> element.
     * @param route - route definition.
     * @author Kacper Faber
     */
    const render = (route: Route) => {
        return (
            <BrowserRoute
                key={route.path}
                path={route.path}
                element={route.element}
            />
        );
    }

    return (
        <BrowserRouter>
            <BrowserRoutes>
                <BrowserRoute element={<Secured children={<Layout/>}/> }>
                    { Routes.map(render) }
                </BrowserRoute>

                <BrowserRoute
                    path="/login"
                    element={<Login/>}
                />
            </BrowserRoutes>
        </BrowserRouter>
    );
}

// noinspection JSUnusedGlobalSymbols
export default AppRouter;